import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { SearchRequest, SearchResultsService, CountValueFacetItem, SliderFacet } from "@rubbl-search-results";
import { Subscription } from "rxjs";

@Component({
  selector: "app-pills-search-results",
  templateUrl: "./pills-search-results.component.html",
  styleUrls: ["./pills-search-results.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class PillsSearchResultsComponent implements OnInit, OnDestroy {
  searchRequest: SearchRequest = null;
  searchRequestSubscription: Subscription;

  constructor(private searchResultsService: SearchResultsService) {}

  ngOnInit() {
    this.searchRequestSubscription = this.searchResultsService.searchRequest$.subscribe(searchRequest => {
      this.searchRequest = searchRequest;
    });
  }

  ngOnDestroy() {
    this.searchRequestSubscription?.unsubscribe();
  }

  resetMachineType() {
    this.searchRequest.onPrimaryTypeChange();
    this.searchResultsService.filterResults();
  }

  unCheckCountValueFacet(facet: CountValueFacetItem) {
    facet.checked = false;
    this.searchResultsService.filterResults();
  }

  resetRange(sliderFacet: SliderFacet) {
    sliderFacet.uncheck();
    this.searchResultsService.filterResults();
  }
}
